<template>
	<div>
		<b-card no-body class="mr-2" >
			<div class="row mt-3 mb-3 pl-4">
				<div class="col-md-6" :class="mobile ? 'order-2' : 'order-1'">
					
					<h2><i class="fa fa-arrow-left" @click="$router.go(-1)" style="cursor:pointer"></i><span class="ml-3">Work Order Detail</span></h2>
				</div>
			</div>
		</b-card>

		<div v-if="woDetail && woFull.deleted_at" class="text-center">
			<h5 style="color:red">Work Order Ini Telah Dibatalkan.</h5>
		</div>

		<b-card no-body  class="pt-2 pb-2 mt-2 mr-2">
			<div class="row">
				<div class="col-md-2 flex-center">
					<i class="fa fa-chevron-left" style="font-size:90px;" @click="changeWorkOrder('<')"></i>
				</div>
				<!-- {{woDetail}} -->
				<div class="col-md-8  col-12 flex-center" :class="{ 'mb-4 offset-md-2': mobile }">
					<img
						:src="woDetail.image"
						style="max-height:250px; width:auto;max-width:100%;min-height:400px"
						v-if="woDetail.image"
						alt="No Image"
					/>
					<h5 v-else class="text-center">No Image Available</h5>
				</div>
				<div class="col-md-2 flex-center">
					<i class="fa fa-chevron-right" style="font-size:90px;" @click="changeWorkOrder('>')"></i>
				</div>
			</div>
		</b-card>
		<div
			class="row mt-2"
			v-if="woDetail"
			:class="{ cancelled: woFull.deleted_at }"
		>
			<div class="col-md-12 pr-3 h-100">
				<b-card no-body class="p-10">
					<div class="row pr-2">
						<div class="col-8 mt-auto mb-auto">
							<h5 class="mt-2 ml-2 mr-2" style="text-decoration-line: underline;text-underline-offset: 6px;">{{woDetail.tipe}}</h5>
						</div>
						<div class="col-4 mt-auto mb-auto">
							<button
								class="btn btn-primary w-100"
								@click="
									$router.push(
										`/estimator/estimator-application/${form_code}`
									)
								"
							>
								Ke Estimator
							</button>
						</div>
					</div>
					
					<div class="row mb-4 mt-3 pb-1 pl-2 pr-2">
						<div class="col-md-4 col-12 mt-1" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Work Order ID
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.work_order_id
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									No Mesin
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.nomor_mesin
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									No Rangka
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.nomor_rangka
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									No Polisi
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.nomor_polisi
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Tipe
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.tipe
									}}</b>
								</div>
							</div>

						</div>
						<div class="col-md-4 col-12 mt-1" style="font-size:14px">
							<div class="row">
								<div class="col-5 mt-1">
									Tanggal Masuk
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.tanggal_masuk
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Pelanggan
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.pelanggan
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Nama Alias
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woDetail.customer && woDetail.customer.alias ? woDetail.customer.alias : '-'}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									CSO
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.cso
									}}</b>
								</div>
							</div>
							
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Warna / Tahun
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woDetail.color}} / {{
										woDetail.year
									}}</b>
								</div>
							</div>
							
						</div>
						<div class="col-md-4 col-12 mt-1" style="font-size:14px">
							<div class="row">
								<!-- <th>Diperiksa Oleh:</th>
								<td>{{ woDetail.check_by }}</td> -->
								<div class="col-5 mt-1">
									Diperiksa Oleh
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.check_by
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Nomor Telpon
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.customerPhoneNumber
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Tanda Terima Mobil
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.conditionChecked
											? "Sudah Di-periksa"
											: "Belum Di-periksa"
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Tipe Service
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.serviceType
									}}</b>
								</div>
							</div>
							
							<div class="row mt-3">
								<div class="col-5 mt-1">
									Tanggal Selesai
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.tanggal_selesai ? woDetail.tanggal_selesai : '-'
									}}</b>
								</div>
							</div>
							
						</div>
						
						<div class="col-12 mt-1" style="font-size:14px">
							<hr>
							<div class="row mt-3">
								<div class="col-4 mt-1">
									Kerusakan
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-7 mt-1">
									
									<b>{{
										woDetail.kerusakan.length > 150
											? woDetail.kerusakan.slice(0, 150) +
											  "...."
											: woDetail.kerusakan
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-4 mt-1">
									Print WO Pertama
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-7 mt-1">
									
									<b>{{
										woDetail.first_printed_at
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-4 mt-1">
									Asuransi
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-7 mt-1">
									
									<b>{{
										woDetail.asuransi
									}}</b>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-4 mt-1">
									Keluhan Customer
								</div>
								<div class="col-md-1 mt-1 d-none d-sm-block">
									:
								</div>
								<div class="col-7 mt-1">
									
									<b>{{
										woDetail.customerRequest
									}}</b>
								</div>
							</div>
						</div>
					</div>

				</b-card>
			</div>
		</div>
		<div class="row pr-2">
			<!-- <div class="col-md-4 mt-3">
				<button
					type="button"
					class="btn btn-primary w-100"
					@click="
						$router.push({
							name: 'EditWorkOrder',
							params: {
								work_order_code: woDetail.work_order_id
							}
						})
					"
				>
					Edit
				</button>
			</div> -->
			<div class="col-md mt-3">
				<button
					type="button"
					class="btn btn-secondary w-100"
					:disabled="woDetail.conditionChecked"
					@click="finishWorkOrderConfirmation('check-car')"
				>
					Periksa Mobil
				</button>
			</div>
			<div class="col-md mt-3">
				<button
					type="button"
					class="btn btn-info w-100"
					@click="modal.selectPrint = true"
				>
					<i class="fa fa-print"></i> Print Options
				</button>
			</div>
		</div>
		<div class="row pr-2">
			<div class="col-md-6 mt-3">
				<button
					type="button"
					class="btn btn-success w-100"
					@click="
						$router.push({
							name: 'InsertCarImage',
							params: {
								form_code: woDetail.work_order_id
							}
						})
					"
				>
					Isi Gambar Mobil
				</button>
			</div>
			<div class="col-md-6 mt-3">
				<button
					@click="cancelWorkOrder(null)"
					type="button"
					class="w-100 btn btn-danger"
				>
					Batalkan Work Order
				</button>
			</div>
		</div>

		<!-- <div class="row">
			<div class="col-md-4" :class="{ 'mb-4': mobile }">
				<img
					:src="woDetail.image"
					class="w-100"
					v-if="woDetail.image"
				/>
				<h5 v-else class="text-center">No Image Available</h5>
			</div>
			<div class="col-md-8">
				<div class="row">
					<div class="col-md-6">
						<table class="wo-stats">
							<tr>
								<th>Work Order ID:</th>
								<td>{{ woDetail.work_order_id }}</td>
							</tr>
							<tr>
								<th>No Mesin:</th>
								<td>{{ woDetail.nomor_mesin }}</td>
							</tr>
							<tr>
								<th>No Rangka:</th>
								<td>{{ woDetail.nomor_rangka }}</td>
							</tr>
							<tr>
								<th>No Polisi:</th>
								<td>{{ woDetail.nomor_polisi }}</td>
							</tr>
							<tr>
								<th>Tahun:</th>
								<td>{{ woDetail.year }}</td>
							</tr>
							<tr>
								<th>Tanggal Masuk:</th>
								<td>{{ woDetail.tanggal_masuk }}</td>
							</tr>
							<tr>
								<th>Asuransi:</th>
								<td>
									{{
										woDetail.asuransi
											? woDetail.asuransi
											: "-"
									}}
								</td>
							</tr>
							<tr>
								<th>:</th>
								<td>
									{{
										woDetail.conditionChecked
											? "Sudah Di-periksa"
											: "Belum Di-periksa"
									}}
								</td>
							</tr>
							<tr>
								<th>Keluhan Mobil Pelanggan:</th>
								<td>{{ woDetail.customerRequest }}</td>
							</tr>
							<tr>
								<th>CSO:</th>
								<td>{{ woDetail.cso }}</td>
							</tr>
							<tr>
								<th>Diperiksa Oleh:</th>
								<td>{{ woDetail.check_by }}</td>
							</tr>
						</table>
					</div>
					<div class="col-md-6">
						<table class="wo-stats">
							<tr>
								<th>Pelanggan:</th>
								<td>{{ woDetail.pelanggan }}</td>
							</tr>
							<tr>
								<th>Nomor Telpon:</th>
								<td>{{ woDetail.customerPhoneNumber }}</td>
							</tr>

							<tr>
								<th>Merek:</th>
								<td>{{ woDetail.merek }}</td>
							</tr>
							<tr>
								<th>Tipe:</th>
								<td>{{ woDetail.tipe }}</td>
							</tr>
							<tr>
								<th>Tanggal Selesai:</th>
								<td>{{ woDetail.tanggal_selesai }}</td>
							</tr>
							<tr>
								<th>Kerusakan:</th>
								<td>
									{{
										woDetail.kerusakan.length > 100
											? woDetail.kerusakan.slice(0, 100) +
											  "...."
											: woDetail.kerusakan
									}}
								</td>
							</tr>
							<tr>
								<th>Print WO Pertama:</th>
								<td>{{ woDetail.first_printed_at }}</td>
							</tr>
							<tr>
								<th>Tipe Service Mobil:</th>
								<td>{{ woDetail.serviceType }}</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4 mt-3">
						<button
							type="button"
							class="btn btn-outline prev-button w-100"
							@click="changeWorkOrder('<')"
						>
							Previous Work Order
						</button>
					</div>
					<div class="col-md-4 mt-3">
						<button
							type="button"
							class="btn btn-outline next-button w-100"
							@click="changeWorkOrder('>')"
						>
							Next Work Order
						</button>
					</div>
					<div class="col-md-4 mt-3">
						<button
							type="button"
							class="btn btn-outline estimator-button w-100"
							@click="
								$router.push({
									name: 'EstimatorApplication',
									params: { id: form_code }
								})
							"
						>
							Ke Estimator
						</button>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4 mt-3">
						<button
							type="button"
							class="btn btn-outline-primary w-100"
							@click="
								$router.push({
									name: 'EditWorkOrder',
									params: {
										work_order_code: woDetail.work_order_id
									}
								})
							"
						>
							Edit
						</button>
					</div>
					<div class="col-md-4 mt-3">
						<button
							type="button"
							class="btn btn-outline-secondary w-100"
							:disabled="woDetail.conditionChecked"
							@click="finishWorkOrderConfirmation('check-car')"
						>
							Periksa Mobil
						</button>
					</div>
					<div class="col-md-4 mt-3">
						<button
							type="button"
							class="btn btn-outline-info w-100"
							@click="modal.selectPrint = true"
						>
							<i class="fa fa-print"></i> Print Options
						</button>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 mt-3">
						<button
							type="button"
							class="btn btn-outline-success w-100"
							@click="
								$router.push({
									name: 'InsertCarImage',
									params: {
										form_code: woDetail.work_order_id
									}
								})
							"
						>
							Isi Gambar Mobil
						</button>
					</div>
					<div class="col-md-6 mt-3">
						<button
							@click="cancelWorkOrder(null)"
							type="button"
							class="w-100 btn btn-outline-danger"
						>
							Batalkan Work Order
						</button>
					</div>
				</div>
			</div>
		</div> -->

		<!-- <hr style="margin:20px" /> -->

		<!-- Estimasi Suku Cadang Start -->
		<div class="pr-2 w-100">
			<b-card class="mt-3" style="width:100%" v-if="estimationData">
				<div class="col-12 w-100" style="overflow-x:auto">
					<h5 style="text-decoration-line: underline;text-underline-offset: 6px;">Tabel Estimasi</h5>
					<table class="table text-center mt-3">
						<thead class="thead-dark">
							<th>No.</th>
							<th>J / P</th>
							<th>Tipe Pengerjaan</th>
							<th>Nama Jasa / Part</th>

							<th>Deskripsi</th>

							<!-- <th>Pricelist Asuransi</th> -->
							<th>Jumlah</th>
							<th>Note</th>
							<!-- <th>Total</th> -->
							<!-- <th>Status Estimasi Part</th> -->
						</thead>
						<tbody
							v-for="(estimationPart, index) in estimationData"
							:key="estimationPart.id"
						>
							<tr>
								<td>{{ index + 1 }}</td>
								<td>{{ estimationPart.sparepart_type }}</td>
								<td>
									{{
										estimationPart.type
											? estimationPart.type
											: "-"
									}}
								</td>
								<td>{{ estimationPart.alias }} {{estimationPart.extension ? '- ' + estimationPart.extension : ''}}</td>

								<td>{{ estimationPart.part_number }}</td>
								<!-- <td>Rp {{estimationPart.insurancePriceList ? numberWithCommas(estimationPart.insurancePriceList.price) : '-'}}</td> -->
								<td>{{ estimationPart.amount }}</td>
								<td>{{estimationPart.additional_information ? estimationPart.additional_information : '-'}}</td>
								<!-- <td>Rp {{estimationPart.price_per_item > 0 ? numberWithCommas(estimationPart.amount * parseInt(estimationPart.price_per_item)) : '0'}}</td> -->
								<!-- <td>
									<span style="color:blue" v-if="estimationPart.is_supplied_by_insurance == 1">Disediakan Oleh Asuransi</span>
									<span style="color:green" v-else-if="estimationPart.is_approved_by_insurance == 1">Disetujui</span>
									<span style="color:red" v-else>Ditolak</span>
								</td> -->
							</tr>
						</tbody>
					</table>
				</div>
			</b-card>
		</div>
		<!-- Estimasi Suku Cadang End -->

		<!-- <hr style="margin:20px" /> -->

		<!-- Step bengkel start -->
		<div class="pr-2">
			<b-card no-body class="mt-4 p-20">
				<div class="row w-100">
					<div class="col-md-6 col-12 align-middle">
						<h5 class="m-0"  style="text-decoration-line: underline;text-underline-offset: 6px;">Step Bengkel Work Order</h5>
					</div>
					<div class="col-md-6 col-12 text-right" :class="mobile ? 'mt-3' : ''">
						<button
							type="button"
							class="btn btn-warning"
							:class="mobile ? 'w-100' : 'w-50'"
							:disabled="woLog"
							:title="
								woProgress.length == 0
									? 'Tambah pekerjaan terlebih dahulu'
									: 'Selesaikan Pekerjaan'
							"
							@click="finishWorkOrderConfirmation('exit-check')"
						>
							{{ woLog ? "WO Sudah Selesai" : "Tutup Work Order" }}
						</button>
						<!-- <button
				type="button"
				class="btn btn-primary"
				@click="modal.add = true"
				:disabled="(woProgress.length != 0 && woProgress[woProgress.length-1].status == 0) || woLog"
				:title="(woProgress.length != 0 && woProgress[woProgress.length-1].status == 0) ? 'Selesaikan pekerjaan terlebih dahulu' : 'Tambah Step'"
				>+ Tambah Step</button> -->
					</div>
				</div>

				<div class="row w-75 mt-5 mb-5" v-if="woProgress.length == 0">
					<div class="col text-center">
						<h5
							class="clickAble"
							style="font-weight: normal; text-decoration: underline;"
							@click="modal.add = true"
						>
							Tambah Step Pekerjaan Untuk Memulai
						</h5>
					</div>
				</div>

				<!-- for loop step -->
				<div class="row mt-3" v-else>
					<div
						class="col-12 col-md-4 p-10 text-center"
						v-for="(listing, index) in woProgress"
					>
						<div class="border border-secondary rounded">
						<!-- {{listing.hide}} -->
							<div v-if="!listing.hide" class="mb-3">
							<!-- <div class="mb-3"> -->
								<div class=" pt-2">
									<div class=" text-center">
										<span
											class="listing-stats"
											style="font-size:20px !important"
										>
											{{ capitalize(listing.step.name) }}
										</span>
										<span class="substep">
											{{
												listing.step.name
													.toLowerCase()
													.includes("epoxy")
													? listing.estimations.length > 0
														?
														getEstimationById(
																listing.estimations[0].id
														).display_name + 
														(getEstimationById(
																listing.estimations[0].id
														).type
																? " - " +
																getEstimationById(
																		listing
																			.estimations[0]
																			.id
																).type
																: "")
														: ""
													: "Step Bengkel"
											}}
										</span>
									</div>
									<div class=" text-center mt-2">
										<i
											v-if="listing.step.icon.includes('fa')"
											class="fas fa-5x"
											:class="listing.step.icon"
											style="color:#424242"
										></i>
										<img
											v-else
											:src="listing.step.icon"
											style="width:auto;height:90px"
										/>
									</div>
									<div class="mt-2">
										<span>Status Pekerjaan</span>
										<h5>
											<span
												v-if="listing.status == -1"
												class="listing-stats"
												style="font-weight:bold; color:red"
												>Dibatalkan</span
											>
											<span
												v-else-if="listing.status == 0"
												class="listing-stats"
												style="font-weight:bold; color:orange"
												>Sedang Dikerjakan</span
											>
											<span
												v-else-if="listing.status == 1"
												class="listing-stats"
												style="font-weight:bold; color:green"
												>Selesai</span
											>
										</h5>
									</div>
								</div>
								<div
									class="row mt-3"
									:class="{ 'mb-3': listing.status != 0 }"
								>
									<div class="col-md-6 pl-3 pr-3">
										<div>
											<span>Pekerjaan Dimulai</span>
											<h5>
												{{
													listing.created_at != null &&
													listing.created_at != ""
														? printDate(listing.created_at)
														: "-"
												}}
											</h5>
										</div>
										<div>
											<span>Dikerjakan Oleh</span>
											<h5 v-if="listing.labourer">
												{{
													
													listing.labourer.name != null &&
													listing.labourer.name != ""
														? listing.labourer.name
														: "-"
												}}
											</h5>
											<button class="btn btn-info w-100" @click="showUpdateLabourer(listing)" v-else>Pilih Pekerja</button>
										</div>
									</div>
									<div class="col-md-6">
										<div>
											<span>Pekerjaan
												{{
													listing.status != -1
														? "Selesai"
														: "Dibatalkan"
												}}
											</span>
											<h5>
												{{
													listing.updated_at != null &&
													listing.updated_at != "" &&
													listing.status != 0
														? printDate(listing.updated_at)
														: "-"
												}}
											</h5>
										</div>
										<div>
											<span>
												{{
													listing.status != -1
														? "Evaluasi"
														: "Dibatalkan"
												}}
												Oleh
											</span>
											<h5>
												{{
													listing.evaluated_by != null &&
													listing.evaluated_by != ""
														? listing.evaluated_by
														: "-"
												}}
											</h5>
										</div>
									</div>
									<div class="col-12 mt-3 pl-3 pr-3">
										<button
											v-if="listing.status == 0"
											type="button"
											class="w-100 btn btn-success"
											@click="finishStep(listing)"
										>
											Selesai
										</button>
										<button
											class="btn btn-outline-primary w-100 mr-3"
											v-else-if="
												listing.status == 1
											"
											:disabled="!listing.step.img_required"
											@click="addImage(listing)"
										>
											+ Gambar
										</button>

									</div>
									<div class="col-md-6 col-12 mt-3 pl-3 pr-3">
										<button
											type="button"
											class="w-100 btn btn-outline-danger"
											@click="cancelConfirmation(listing.id)"
										>
											Batal
										</button>
										
									</div>

									<div class="col-md-6 col-12 mt-3 pl-3 pr-3" v-if="listing.step.name == 'Warna'">
										<button
											class="btn w-100 btn-outline-info mr-2"
											:disabled="listing.status != 1"
											@click="showComposition()"
										>
											Lihat Komposisi
										</button>
									</div>
									
									<div class="col-md-6 col-12 mt-3 pl-3 pr-3" v-else>
										<button
											class="btn w-100 btn-outline-info mr-2"
											:disabled="!listing.img"
											@click="showStep(listing.img)"
										>
											Lihat Gambar
										</button>
									</div>
								</div>
								
							</div>
							<div v-else class="mb-3">
								<div class=" pt-2">
									<div class="row">
										<div class="pl-4 col-9 text-left">
											<span
												class="listing-stats"
												style="font-size:20px !important"
											>
												{{ capitalize(listing.step.name) }}
											</span>
											<span class="substep">
												{{
													listing.step.name
														.toLowerCase()
														.includes("epoxy")
														? listing.estimations.length > 0
															?
															getEstimationById(
																	listing.estimations[0].id
															).display_name + 
															(getEstimationById(
																	listing.estimations[0].id
															).type
																	? " - " +
																	getEstimationById(
																			listing
																				.estimations[0]
																				.id
																	).type
																	: "")
															: ""
														: "Step Bengkel"
												}}
											</span>

											<h5>
												<span
													v-if="listing.status == -1"
													class="listing-stats"
													style="font-weight:bold; color:red"
													>Dibatalkan</span
												>
												<span
													v-else-if="listing.status == 0"
													class="listing-stats"
													style="font-weight:bold; color:orange"
													>Sedang Dikerjakan</span
												>
												<span
													v-else-if="listing.status == 1"
													class="listing-stats"
													style="font-weight:bold; color:green"
													>Selesai</span
												>
											</h5>
										</div>
										<div class="col-3">
											<i class="fa fa-eye fa-4x" @click="listing.hide = false"></i>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6 pl-4 pr-4 text-left">
											<div>
												<span>Pekerjaan Dimulai</span>
												<h5>
													{{
														listing.created_at != null &&
														listing.created_at != ""
															? printDate(listing.created_at)
															: "-"
													}}
												</h5>
											</div>
											<!-- <div>
												<span>Dikerjakan Oleh</span>
												<h5 v-if="listing.labourer">
													{{
														
														listing.labourer.name != null &&
														listing.labourer.name != ""
															? listing.labourer.name
															: "-"
													}}
												</h5>
												<button class="btn btn-info w-100" @click="showUpdateLabourer(listing)" v-else>Pilih Pekerja</button>
											</div> -->
										</div>
										<div class="col-md-6 pl-4 pr-4 " :class="mobile ? 'text-left' : 'text-right'">
											<div>
												<span>Pekerjaan
													{{
														listing.status != -1
															? "Selesai"
															: "Dibatalkan"
													}}
												</span>
												<h5>
													{{
														listing.updated_at != null &&
														listing.updated_at != "" &&
														listing.status != 0
															? printDate(listing.updated_at)
															: "-"
													}}
												</h5>
											</div>
											<!-- <div>
												<span>
													{{
														listing.status != -1
															? "Evaluasi"
															: "Dibatalkan"
													}}
													Oleh
												</span>
												<h5>
													{{
														listing.evaluated_by != null &&
														listing.evaluated_by != ""
															? listing.evaluated_by
															: "-"
													}}
												</h5>
											</div> -->
										</div>
										<!-- <div class="col-12 mt-3 pl-3 pr-3">
											<button
												type="button"
												class="w-100 btn btn-outline-info"
												@click="listing.hide = false"
											>
												Perlihatkan Step Bengkel
											</button>

										</div> -->
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pt-2 pb-2" style="">
						<button
							type="button"
							class="btn btn-primary w-100"
							@click="modal.add = true"
							:title="'Tambah Step'"
						>
							+ Tambah Step
						</button>
					</div>
				</div>
			</b-card>
		</div>
		<!-- Step bengkel end -->

		<!-- Modals Start -->
		<new-step-listing
			v-if="modal.add"
			:form_code="form_code"
			:estimationData="estimationData"
			@updateTable="getWoProgress"
			@closeModal="modal.add = false"
		></new-step-listing>
		
		<selecta-labourer
			v-if="modal.showLabourerSelection"

			@updateTable="updateLabourer"
			@closeModal="modal.showLabourerSelection = false"
		></selecta-labourer>

		<upload-image
			v-if="modal.uploadImage"
			endpoint="/api/v1/workorder/steps/upload"
			:title="titleUpload"
			:image_count="titleUpload.toLowerCase().includes('epoxy') ? 5 : 1"
			@closeModal="modal.uploadImage = false"
			@onResponse="finishUploadImage"
		></upload-image>

		<upload-image
			v-if="modal.addImage"
			endpoint="/api/v1/workorder/steps/upload"
			:title="titleAddImage"
			:image_count="titleAddImage.toLowerCase().includes('epoxy') ? 5 : 1"
			@closeModal="modal.addImage = false"
			@onResponse="finishAddImage"
		></upload-image>

		<preview-image
			v-if="modal.showOverallImage"
			@closeModal="modal.showOverallImage = false"
			:title="'Gambar WO ' + woDetail.work_order_id"
			:image="imagesList"
		></preview-image>

		<preview-image
			v-if="modal.showStepImage"
			@closeModal="modal.showStepImage = false"
			:image="stepImage"
		></preview-image>

		<download-image
			v-if="modal.downloadImage"
			@closeModal="modal.downloadImage = false"
			:form_code="form_code"
			:list="imagesList"
		></download-image>

		<transition name="modal" v-if="modal.selectPrint">
			<div class="modal-mask">
				<div class="modal-wrapper">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
							<div class="modal-container" @click.stop>
								<div
									class="modal-header row others"
									style="justify-content: flex-end;"
								>
									<!-- <div class="col-6">
                      <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                    </div> -->
									<div class="col">
										<button
											type="button"
											class="close"
											@click="modal.selectPrint = false"
										>
											<span aria-hidden="true"
												>&times;</span
											>
										</button>
									</div>
								</div>

								<div
									class="modal-body"
									style="min-height:350px"
								>
									<h2 class="title">Print Options</h2>

									<div class="form-group">
										<label class="label text-left"
											>Select Print Type</label
										>
										<Multiselect
											:options="
												printTypes.map(x => x.variable)
											"
											:custom-label="
												opt =>
													printTypes.find(
														x => x.variable == opt
													).name
											"
											v-model="selectPrintType"
										/>
									</div>
									<hr />

									<div v-if="selectPrintType">
										<print-work-order
											v-if="modal.printTT"
											@closeModal="modal.printTT = false"
											:data="woFull"
											:complete="true"
											:estimationData="estimationData"
										></print-work-order>

										<print-work-order
											v-if="modal.printWO"
											@closeModal="modal.printWO = false"
											:data="woFull"
											:complete="false"
											:estimationData="estimationData"
										></print-work-order>
										<printFinish
											v-if="modal.printFinish"
											@closeModal="modal.printWO = false"
											:data="woFull"
											:complete="false"
											:estimationData="estimationData"
										/>

										<print-identity
											v-if="modal.printIdentity"
											@closeModal="
												modal.printIdentity = false
											"
											:data="woFull"
											:estimationData="estimationData"
										></print-identity>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
				</div>
			</div>
		</transition>

		<adminAuth
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			:request="`Cancel Work Order : ${woDetail.work_order_id}`"
			@approved="allowCancelWorkOrder"
			@token="cancelWorkOrder"
		/>

		<showPaintComposition 
			v-if="colorData"
			@closeModal="colorData = null"
			:paintList="colorData"
		/>

		<!-- Modals End -->
	</div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";

import newStepListing from "./children/newStepListing";
import env from "@/env";

import printWorkOrder from "./children/printWorkOrder";
import printIdentity from "./children/printIdentity";
import printFinish from "./children/printFinsihWO";

import uploadImage from "@/components/modal/uploadImage";
import previewImage from "@/components/modal/previewImage";
import adminAuth from "@/components/modal/adminAuthorization";
import downloadImage from "./children/downloadImage";
import selectaLabourer from './children/selectLabourer.vue'
import showPaintComposition from './children/showPaintComposition.vue'

export default {
	data() {
		return {
			env,
			moment,
			mobile: this.isMobile(),
			reason: "",
			modal: {
				showAdminAuth: false,
				add: false,
				selectPrint: false,

				printTT: false,
				printWO: false,
				printIdentity: false,
				printFinish: false,

				uploadImage: false,
				addImage: false,
				showOverallImage: false,
				showStepImage: false,
				downloadImage: false,
				showLabourerSelection : false
			},
			currentSelectedAddImage: null,
			currentSelectedUploadImage: null,
			titleUpload: "",
			titleAddImage: "",
			printTypes: [
				{
					name: "Print Identitas Customer",
					variable: "printIdentity"
				},
				{
					name: "Print Tanda Terima",
					variable: "printTT"
				},
				{
					name: "Print Work Order",
					variable: "printWO"
				},
				{
					name: "Print Kondisi Mobil Selesai",
					variable: "printFinish"
				}
			],
			selectPrintType: null,
			prevPrintType: null,
			form_code: this.$route.query.wo,
			options: {
				woSteps: this.$store.getters.getWoSteps
			},
			woLog: null,
			estimationData: [],
			woFull: null,
			woDetail: {
				work_order_id: "-",
				nomor_mesin: "-",
				nomor_rangka: "-",
				nomor_polisi: "-",
				asuransi: "-",
				kerusakan: "-",
				tanggal_masuk: "-",
				tanggal_selesai: "-",
				pelanggan: "-",
				cso: "-",
				merek: "-",
				tipe: "-",
				first_printed_at: "-"
			},
			woProgress: [],
			figureGrouping: {
				front: [
					"front_bumper",
					"front_left_light",
					"front_right_light",
					"front_windshield",
					"grill",
					"left_fog_light",
					"right_fog_light"
				],
				rear: [
					"rear_bumper",
					"rear_left_light",
					"rear_right_light",
					"rear_windshield"
				],
				left: [
					"front_left_door",
					"front_left_fender",
					"front_left_wheel",
					"rear_left_door",
					"rear_left_fender",
					"rear_left_wheel"
				],
				right: [
					"front_right_door",
					"front_right_fender",
					"front_right_wheel",
					"rear_right_door",
					"rear_right_fender",
					"rear_right_wheel"
				],
				atap: ["roof", "sunroof"]
			},
			imagesList: [],
			stepImage: "",
			tempListing : null,
			colorData : null
		};
	},
	components: {
		newStepListing,
		Multiselect,

		printWorkOrder,
		printIdentity,
		printFinish,

		uploadImage,
		previewImage,
		downloadImage,
		adminAuth,
		selectaLabourer,
		showPaintComposition
	},
	watch: {
		selectPrintType: function() {
			// this.prevPrintType ? this.prevPrintType == this.selectPrintType :
			if (this.prevPrintType) {
				this.modal[this.prevPrintType] = false;
			}

			this.prevPrintType = this.selectPrintType;

			if (
				this.selectPrintType == "printTT" ||
				this.selectPrintType == "printWO"
			)
				this.showPrint(this.selectPrintType);
			else this.modal[this.selectPrintType] = true;
		}
	},
	mounted() {
		this.getWoDetails();
		this.getWoProgress();
		this.getWoLog();
	},
	methods: {
		showComposition () {
			this.$http.get(`/api/v1/masterData/customer_car/${this.woDetail.nomor_rangka}/car_paint`)
			.then((resp)=>{
				// this.colorData = resp.data.data;
				let data = resp.data.data;
				let newObj = []

				for(var i = 0 ; i < data.length ; i++) {
					let curData = data[i]

					if(curData.form_code != this.woDetail.work_order_id) continue;

					let index = newObj.findIndex(x => x.form_code === curData.form_code)

					if(index == -1) {
						newObj.push({
							form_code : curData.form_code,
							form_dibuat : moment(curData.form_dibuat).format('MMM DD,Y'),
							data : [curData]
						})
					}
					else {
						newObj[index].data.push(curData)
					}
				}
				console.log(newObj)
				this.colorData = newObj[0]
				
			})
			.catch((err)=>{
				console.log(err);
			})

		},
		showUpdateLabourer(listing) {
			this.tempListing = listing
			this.modal.showLabourerSelection = true
		},
		updateLabourer (labourer_id) {
			this.$http.patch(`/api/v1/workorder/steps/${this.tempListing.id}/update`, {labourer_id : labourer_id})
			.then((resp) => {
				// console.log(resp.data.data)
				this.$store.dispatch('triggerAlert' , [true , 'Pilih Pekerja Sukses.'])
				this.getWoProgress()
			})
			.catch((err) => {
				console.log(err)
			})
		},
		backUrl() {
			if (this.$route.params.type == "wo")
				this.$router.push("/work-order-form");
			else {
				this.$router.push("/work-order-step");
			}
		},
		changeWorkOrder(type) {
			let url = `/api/v1/workorder/sequence?type=${type}&workOrder=${this.woDetail.work_order_id}`;
			this.$http
				.get(url)
				.then(resp => {
					let data = resp.data.data;

					this.$router.replace({
						name: "WorkOrderDetailV2",
						query: { wo: data.form_code }
					});
					this.form_code = data.form_code;
					this.getWoDetails();
					this.getWoProgress();
					this.getWoLog();
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("triggerAlert", [
						false,
						"No Previous / Next Work Order"
					]);
				});
		},
		allowCancelWorkOrder(token, prevToken) {
			this.modal.showAdminAuth = false;

			if (token) {
				this.$http.defaults.headers.common["Authorization"] = prevToken;
			}

			this.$http
				.delete("/api/v1/workorder/" + this.woDetail.work_order_id)
				.then(resp => {
					if (token)
						this.$store.dispatch("triggerAlert", [
							true,
							"Admin Permission Success. Work Order " +
								this.woDetail.work_order_id +
								" Successfully Deleted"
						]);
					else
						this.$store.dispatch("triggerAlert", [
							true,
							"Work Order " +
								this.woDetail.work_order_id +
								" Successfully Deleted"
						]);

					this.$router.push({ name: "WorkOrderForm" });
				})
				.catch(err => {
					this.$store.dispatch("triggerAlert", [
						false,
						"Oops Something Went Wrong. Please Try Again Later."
					]);
					console.log(err);
				});
		},
		cancelWorkOrder(token = null) {
			let prevToken = "";

			if (token) {
				prevToken = this.$http.defaults.headers.common["Authorization"];

				this.$http.defaults.headers.common["Authorization"] =
					"Bearer " + token;
			}

			let now = new moment();
			let startTime = new moment(this.woDetail.tanggal_masuk);
			var duration = moment.duration(now.diff(startTime));
			var hours = duration.asHours();

			if (hours <= 2) {
				this.allowCancelWorkOrder(null, null);
			} else {
				this.$http
					.get("/api/v1/check")
					.then(resp => {
						let data = resp.data.data;
						let super_user = data.is_superuser;

						if (super_user) {
							this.allowCancelWorkOrder(token, prevToken);
						} else {
							this.modal.showAdminAuth = true;
							this.reason = token
								? "Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya."
								: "Fitur tersebut hanya bisa dipakai pada 2 Jam Pertama Setelah Pembikinan Work Order Atau Otorisasi Admin.";
						}
					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		showPrint(variable) {
			if (
				this.woDetail.serviceType != "Rawat Jalan" &&
				!this.woDetail.conditionChecked
			) {
				this.$store.dispatch("triggerAlert", [
					false,
					"Mohon Diperiksa Mobil Terlebih Dahulu Sebelum Memakai Fitur ini."
				]);
				return;
			}

			this.modal[variable] = true;
		},
		showStep(x) {
			this.stepImage = x;
			this.stepImage = this.stepImage.map(x => env.baseImage + "/" + x);
			this.modal.showStepImage = true;
		},
		finishStep(listing) {
			//1st step
			let step_name = listing.step.name.toLowerCase().includes("epoxy");

			if (
				step_name &&
				this.getEstimationById(listing.estimations[0].id).type != "G/C"
			) {
				this.titleUpload = `Unggah Gambar untuk Step ${
					listing.step.name
				} ${
					listing.step.name.toLowerCase().includes("epoxy")
						? listing.estimations.length > 0
							? "- " +
							  this.getEstimationById(listing.estimations[0].id)
									.part_number +
							  (this.getEstimationById(listing.estimations[0].id)
									.type
									? " - " +
									  this.getEstimationById(
											listing.estimations[0].id
									  ).type
									: "")
							: ""
						: ""
				} `;
				this.modal.uploadImage = true;
				this.currentSelectedUploadImage = listing;
			} else if (!step_name && listing.step.img_required) {
				this.titleUpload = `Unggah Gambar untuk Step ${
					listing.step.name
				} ${
					listing.step.name.toLowerCase().includes("epoxy")
						? listing.estimations.length > 0
							? "- " +
							  this.getEstimationById(listing.estimations[0].id)
									.part_number +
							  (this.getEstimationById(listing.estimations[0].id)
									.type
									? " - " +
									  this.getEstimationById(
											listing.estimations[0].id
									  ).type
									: "")
							: ""
						: ""
				} `;
				this.modal.uploadImage = true;
				this.currentSelectedUploadImage = listing;
			} else this.finishConfirmation(listing, null);
		}, //2nd (optional only if image is needed)
		finishUploadImage(data) {
			// console.log(typeof data == 'string' , this.titleUpload.toLowerCase().includes('epoxy') ,  this.estimationData.filter(x=>x.sparepart_type == 'J').length)
			// if (this.titleUpload.toLowerCase().includes('epoxy') && (typeof data != 'string' && data.length != this.estimationData.filter(x=>x.sparepart_type == 'J').length)){
			//   this.$store.dispatch('triggerAlert', [false, [`Gambar harus ada ${this.estimationData.filter(x=>x.sparepart_type == 'J').length} buah`]])
			//   return;
			// }

			this.finishConfirmation(
				this.currentSelectedUploadImage,
				Array.isArray(data) ? data : [data]
			);
			this.modal.uploadImage = false;
		},
		finishWorkOrderConfirmation(type) {

			// if (this.woDetail.serviceType == 'Rawat Jalan') {
			// 	this.$http.patch('/api/v1/workorder/done/' + this.form_code)
			// 	.then((resp)=> {
			// 		// this.data.form_code = resp.data.data.form_code
			// 		// this.$store.state.lastData = null
			// 		// this.apiLoading = false
			// 		// this.$store.state.lastDataExitCheck = null
			// 		this.$store.dispatch('triggerAlert' , [true , 'WO Berhasil Ditutup'])
			// 		this.getWoDetails()
			// 		this.getWoLog()
			// 		// this.$router.push({name : 'WorkOrderDetailV2', query: {wo:this.$route.params.form_code.replace(/"/g, "")}})

			// 	})
			// 	.catch((err) => {
			// 		this.$store.dispatch('triggerAlert' , [false , 'Error!' , err])
			// 		console.log(err)
			// 	})
			// 	return
			// }

			if(this.woDetail.serviceType == 'Process Mobil') {
				// this.$store.dispatch('triggerAlert' , [false  , ''])
				this.$swal({
					icon : 'error',
					title : 'Error',
					html : 'Akses Ditolak. Harap untuk memakai prosedur Merge Work Order di Tanda Terima Only.'
				})
				return
			}


			if (type == "exit-check") {
				// console.log(this.woProgress)
				if(!this.env.workorderOptions.allowTutupWoStepBengkel) {
					if (this.woProgress.length == 0) {
						this.$swal.fire({
							title : 'Tutup Work Order Ditolak!',
							text : 'Step Bengkel untuk work order tidak boleh kosong',
							icon : "error"
						})
						return
					}

					let ongoingWorkOrder = this.woProgress.filter(x => x.status == 0)
					if (ongoingWorkOrder.length > 0) {
						this.$swal.fire({
							title : 'Tutup Work Order Ditolak!',
							text : 'Mohon Diselesaikan semua step bengkel terlebih dahulu untuk menutup work order ini',
							icon : "error"
						})
						return
					}
				}
				

				this.$swal
					.fire({
						title: "Apakah anda yakin?",
						text:
							"Anda akan menutup work order ini, selesai dan tidak dapat menambah pekerjaan!",
						icon: "warning",
						showCancelButton: true
					})
					.then(result => {
						if (result.value) {
							this.$router.push({
								name: "exitCheckV2",
								params: {
									form_code: this.form_code,
									type: type
								}
							});
							// this.$http.post(`/api/v1/workorder/log/done/${this.form_code}`)
							// .then((resp)=>{
							//   this.$swal.fire(
							//     'Berhasil!',
							//     `Work Order ${this.form_code} telah berhasil diselesaikan.`,
							//     'success'
							//   )
							// })
							// .catch((err)=>{console.log(err);})
						}
					});
			} else {
				this.$router.push({
					name: "exitCheckV2",
					params: {
						form_code: this.form_code,
						type: type
					}
				});
			}
		},
		cancelConfirmation(listing_id) {
			this.$swal
				.fire({
					title: "Apakah anda yakin?",
					text: "Step akan dibatalkan!",
					icon: "warning",
					showCancelButton: true
				})
				.then(result => {
					if (result.value) {
						this.$http
							.patch(
								`/api/v1/workorder/steps/${listing_id}/cancel`
							)
							.then(resp => {
								this.getWoProgress();
								this.$swal.fire(
									"Berhasil!",
									"Step telah berhasil dibatalkan",
									"success"
								);
							})
							.catch(err => {
								console.log(err);
							});
					}
				});
		}, //3rd / final step
		finishConfirmation(listing, data) {
			console.log(listing, data);
			this.$swal
				.fire({
					title: "Apakah anda yakin?",
					text: `Anda akan mengubah status step ${listing.step.name} selesai`,
					icon: "warning",
					showCancelButton: true
				})
				.then(result => {
					if (result.value) {
						this.$http
							.patch(
								`/api/v1/workorder/steps/${listing.id}/done`,
								data
									? {
											data: {
												img: data
											}
									  }
									: ""
							)
							.then(resp => {
								if (resp.data.data.img) {
									// let imgList = resp.data.data.img.split(",");

									// for (var i = 0; i < imgList.length; i++) {
									// 	console.log(imgList[i]);
									// 	let url =
									// 		env.baseImage + "/" + imgList[i];
									// 	const a = document.createElement("a");
									// 	a.style.display = "none";
									// 	a.href = url;
									// 	a.target = "_blank";
									// 	// the filename you want
									// 	a.download = `${listing.step.name} - ${this.form_code}.jpg`;
									// 	document.body.appendChild(a);
									// 	a.click();
									// }
								}

								this.$swal.fire(
									"Berhasil!",
									`${listing.step.name} telah berhasil diubah menjadi selesai`,
									"success"
								);
								this.getWoProgress();
							})
							.catch(err => {
								console.log(err);
							});
					}
				});
		},
		getWoLog() {
			this.$http
				.get("/api/v1/workorder/log/" + this.form_code)
				.then(resp => {
					let data = resp.data.data;
					this.woLog = data.find(x => x.log_id == 4);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getWoDetails() {
			this.$http
				.get(`/api/v1/workorder/${this.form_code}/detail`)
				.then(async resp => {
					var data = resp.data.data;
					let carDetail = data.customer_car
						? this.$store.getters.getModelDetailById(
								data.customer_car.car_id
						  )
						: "-";

					// alert(data.details.conditionChecked)

					console.log(data);

					this.woDetail = {
						work_order_id: this.form_code,
						nomor_mesin: data.customer_car
							? data.customer_car.engine_number
							: "-",
						nomor_rangka: data.customer_car
							? data.customer_car.chassis_number
							: "-",
						nomor_polisi: data.customer_car
							? data.customer_car.registration
							: data.registration
							? data.registration
							: "-",
						insuranceList: data.customer_car
							? data.customer_car.insurance
							: "-",
						kerusakan: data.condition ? this.evaluateDamage(data.condition.figure) : '-',
						tanggal_masuk: moment(data.created_at).format(
							"DD MMM YY HH:mm"
						),
						tanggal_selesai: data.finishDate
							? moment(data.finishDate).format("DD MMM Y")
							: "-",
						pelanggan: data.customer ? data.customer.name : "-",
						cso: data.CSO,
						check_by: data.check_by ? data.check_by : "-",
						year: data.customer_car ? data.customer_car.year : "-",
						merek: data.customer_car ? carDetail.brand_name : "-",
						color : data.customer_car ? data.customer_car.car_color.name : '-',
						tipe: data.customer_car ? carDetail.name : "-",
						serviceType: data.serviceType,
						image: data.condition && data.condition.imageList && data.condition.imageList[0] ? 
							data.condition.imageList[0] : 
						data.condition && data.condition.figureOverall && Array.isArray(
							data.condition.figureOverall.front.image
						)
							? data.condition.figureOverall.front.image[0]
							: null,
						conditionChecked: data.details.conditionChecked === 0 ? false : true,
						first_printed_at: data.first_printed_at
							? moment(data.first_printed_at).format(
									"DD MMM YY HH:mm:ss"
							  )
							: "-",
						warna: data.customer_car
							? data.customer_car.paint_name
								? data.customer_car.paint_name
								: "-"
							: "-",
						customerRequest: data.condition && data.condition.customerRequest
							? data.condition.customerRequest
							: "-",
						customerPhoneNumber:
							data.customer && data.customer.phone_number
								? data.customer.phone_number
								: "-",
						customer : data.customer
					};

					this.woDetail.image = `${env.baseImage}/${this.woDetail.image}`;
					console.log(this.woDetail.image);

					this.woFull = data;
					data.form_code = this.form_code;
					this.getEstimationTable();

					if(!this.woDetail.image.includes('test image')) {
						this.imagesList = await this.parseImages(
							data.condition.figureOverall,
							data.condition.figure
						);
					}
					
					
				})
				.catch(err => {
					console.log(err);
				});
		},
		getWoProgress() {
			this.$http
				.get(`/api/v1/workorder/steps/${this.form_code}`)
				.then(resp => {
					this.woProgress = Object.assign([], resp.data.data);

					for (var i = 0; i < this.woProgress.length; i++) {
						if (this.woProgress[i].status == 1)
							this.$set(this.woProgress[i], "hide", true);
						else this.$set(this.woProgress[i], "hide", false);
					}

					this.woProgress = this.woProgress.sort(function(a, b) {
						return parseFloat(a.step_id) - parseFloat(b.step_id);
					})
					console.log(this.woProgress)
				})
				.catch(err => {
					console.log(err);
				});
		},
		evaluateDamage(figure) {
			var damages = "";
			for (var i in figure) {
				for (var j in figure[i]) {
					if (figure[i][j].desc != "")
						damages += `${this.toCapitalizedWords(j)}, `;
				}
			}

			return damages ? damages.substring(0, damages.length - 2) : "-";
		},
		parseImages(figureOverall, figure) {
			var images = [];
			var figureGrouping = this.figureGrouping;

			var englishIndoDictionary = {
				front: "depan",
				rear: "belakang",
				left: "kiri",
				right: "kanan",
				atap: "atap"
			};

			for (var i in figureGrouping) {
				//Figure Overall
				if (figureOverall[i]) {
					if (typeof figureOverall[i] == "string")
						images.push({
							image: env.baseImage + "/" + figureOverall[i],
							// description: `Bagian tampak '${i}'.`
						});
					else if (typeof figureOverall[i] == "object") {
						if (figureOverall[i].desc == "") continue;
						for (var j in figureOverall[i].image) {
							if (!figureOverall[i].image[j]) continue;
							images.push({
								image:
									env.baseImage +
									"/" +
									figureOverall[i].image[j],
								description: `Bagian tampak ${
									englishIndoDictionary[i]
								}.
								${
									figureOverall[i].image.length > 1
										? " Gambar " +
										  (parseInt(j) + 1) +
										  " dari " +
										  figureOverall[i].image.length +
										  "."
										: ""
								}`
							});
						}
					}
				}

				//Damages / Kerusakan
				for (var j in figure[i]) {
					//Single Part (kacaDepan, atapMobil, etc.)
					if (figure[i][j] && figure[i][j].desc != "") {
						for (var k in figure[i][j].image) {
							if (!figure[i][j].image[k]) continue;
							images.push({
								image:
									env.baseImage + "/" + figure[i][j].image[k],
								description: `Bagian ${
									englishIndoDictionary[i]
								}. Kerusakan '${this.toCapitalizedWords(
									j
								)}'. Deskripsi : '${figure[i][j].desc}'. ${
									figure[i][j].image.length > 1
										? " Gambar " +
										  (parseInt(k) + 1) +
										  " dari " +
										  figure[i][j].image.length +
										  "."
										: ""
								}`
							});
						}
					}
				}

				//Old Damages / Kerusakan Parser
				// for (var j in figureGrouping[i]){
				//   if (figure[figureGrouping[i][j]]) {
				//     if (typeof figure[figureGrouping[i][j]] == 'string')
				//       images.push({image:figure[figureGrouping[i][j]],
				//       description:`Bagian '${i}'. Kerusakan '${this.toCapitalizedWords(figureGrouping[i][j])}'.`
				//     })
				//     else if (typeof figure[figureGrouping[i][j]] == 'object'){
				//       for (var k in figure[figureGrouping[i][j]].image) images.push({
				//         image:figure[figureGrouping[i][j]].image[k],
				//         description:`Bagian '${i}'. Kerusakan '${this.toCapitalizedWords(figureGrouping[i][j])}'. Deskripsi : '${figure[figureGrouping[i][j]].desc}'. ${(figure[figureGrouping[i][j]].image.length > 1) ? ' Gambar ' + (parseInt(k)+1) + ' dari ' + figure[figureGrouping[i][j]].image.length + '.' : ''}`
				//       })
				//     }
				//   }
				// }
			}

			return images;
		},
		async getEstimationTable() {

			let listOfPO = await this.getPurchaseOrderDetails()
			this.$http
				.get(`/api/v1/workorder-estimation/${this.form_code}`)
				.then(resp => {
					let data = resp.data.data.estimations.filter(
						x => x.is_approved_by_insurance && x.deleted_at == null
					);

					for(var i = 0 ; i < data.length ; i++) {
						let curData = data[i]
						if (curData.sparepart_type == "P") {
							let poDetails = listOfPO.find(
								(x) =>
									x.estimation_id == curData.id &&
									!x.next_purchase_order_item
							);
							if (poDetails) {
								console.log(poDetails)
								// curData.is_po = true;
								if(poDetails.is_used)
									curData.additional_information = `Barang Datang Pada ${moment(poDetails.time_of_arrival).format('MMM DD,Y HH:mm')} Dan Telah Dipakai`
								else if(poDetails.is_arrived)
									curData.additional_information = `Barang Datang Pada ${moment(poDetails.time_of_arrival).format('MMM DD,Y HH:mm')}`
								else
									curData.additional_information = `Barang Belum Datang`

							} else {
								curData.additional_information = `Barang Belum Dipesan`
							}
						}
					}

					this.estimationData = data

					

					



					let insurance_id = resp.data.data.details.insurance_id;
					if (insurance_id) {
						this.woDetail.asuransi = this.woDetail.insuranceList.find(
							x => x.id == insurance_id
						).insuranceCompany.company_name;
						this.woFull.asuransi = this.woDetail.asuransi;
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		async getPurchaseOrderDetails() {
			let result = await this.$http.get(
				"/api/v1/purchase-order/" + this.form_code
			);

			return result.data.data;
		},
		getEstimationById(id) {
			let res = this.estimationData.filter(x => x.id == id);
			// res = res.length > 0  res[0] : []
			if(res.length > 0) {
				res = res[0]
				res.display_name = `${res.alias} ${res.extension ? res.extension : ''} ${res.part_number ? '- ' +  res.part_number : ''}`
			}
			else 
				res = []


			return res;
		},
		addImage(listing) {
			this.currentSelectedAddImage = listing;
			this.titleAddImage = `Tambah Gambar untuk Step ${listing.step.name}`;
			this.modal.addImage = true;
		},
		finishAddImage(trfData) {
			this.modal.addImage = false;
			let listing = this.currentSelectedAddImage;
			let data = Array.isArray(trfData) ? trfData : [trfData];
			if (listing.img) data = data.concat(listing.img);

			this.$swal
				.fire({
					title: "Apakah anda yakin?",
					text: `Anda akan menambahkan gambar pada status step ${listing.step.name}`,
					icon: "warning",
					showCancelButton: true
				})
				.then(result => {
					if (result.value) {
						this.$http
							.patch(
								`/api/v1/workorder/steps/${listing.id}/done`,
								data
									? {
											data: {
												img: data
											}
									  }
									: ""
							)
							.then(resp => {
								this.$swal.fire(
									"Berhasil!",
									`${listing.step.name} telah berhasil ditambahkan gambar`,
									"success"
								);

								this.getWoProgress();
							})
							.catch(err => {
								console.log(err);
							});
					}
				});
		}
	}
};
</script>

<style scoped>
.wo-stats th {
	font-size: 16px;
}

.wo-stats td {
	padding-left: 10px;
}

.wo-listing-box {
	margin-top: 20px;
	border: 1px solid #4f4f4f;
	border-radius: 5px;
}

.wo-listing-box .listing-stats {
	font-size: 16px;
	margin: 0;
}

.wo-listing-box th {
	font-size: 16px;
	padding-right: 10px;
}

.wo-listing-box td {
}

.clickAble:hover {
	cursor: pointer;
}
</style>

<style scoped>
.hoverStatus:hover {
	background-color: #999;
}
</style>

<style scoped>
.next-button {
	border-color: rgb(219, 207, 136);
}
.prev-button {
	border-color: rgb(206, 136, 136);
}
.estimator-button {
	border-color: rgb(48, 84, 245);
}
.estimator-button:hover {
	background-color: rgb(48, 84, 245);
	color: black;
}
.next-button:hover {
	background-color: rgb(219, 207, 136);
	color: black;
}
.prev-button:hover {
	background-color: rgb(189, 104, 104);
	color: black;
}
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.flex-center {
	display : flex;
	justify-content: center;
	align-items: center;
}

.fa-chevron-left {
	cursor : pointer;
}

.fa-chevron-right {
	cursor : pointer;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

.companyDetails {
	margin-bottom: 5px;
	font-size: 0.6rem;
}
/* .documentTitle{
  font-size: 40px;
  border: 1px solid black;
  border-radius: 10px;
  padding:20px 30px;
} */
.contentTitle {
	font-size: 14px;
	font-weight: 700;
}
.contentVariable {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
}

.substep {
	color : #666;
	font-size: 12.5px;
}
</style>
